<template>
  <div>
    <div
      v-if="selected"
      class="flex justify-between items-center form-input bg-gray-100 rounded border-gray-100"
    >
      {{ selected.name }}
      <button type="button" @click="clear">
        <BaseIcon name="x" />
      </button>
    </div>
    <AjaxSearch
      v-else
      url="/search/organizations"
      name="organization_id"
      :value="value"
      :error="error"
      @select="select"
      placeholder="Zoek een organisatie"
    >
      <template v-slot="{ row }">{{ row.name }}</template>
    </AjaxSearch>
  </div>
</template>

<script>
import AjaxSearch from "./AjaxSearch";

export default {
  props: {
    value: [String, Number],
    error: String
  },

  components: {
    AjaxSearch
  },

  data() {
    return {
      selected: null
    };
  },

  methods: {
    select(row) {
      this.selected = row;
      this.$emit("input", row.id);
    },

    clear() {
      this.selected = null;
      this.$emit("input", null);
    }
  }
};
</script>